import React from "react";

// EXTRAS
import { cleanSpecialCharacters } from "../../extras";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";
import Stack from "@mui/material/Stack";
import { calculateRadius } from "../../utils/orders";
import { formatFinance } from "../../utils/formatters";

export default function OrderTicketFinancialInfos({
  payment,
  payment_pending,
  total,
  changeFor,
  distance,
}) {
  const moneyTotal = payment
    .filter((p) => p.payment_method === "DINHEIRO")
    .reduce((sum, p) => sum + parseFloat(p.value), 0);

  return (
    <Box>
      {payment.map((payment) => {
        return (
          <Stack
            direction="row"
            justifyContent="space-between"
            key={payment.id}
          >
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              {payment.prepaid ? (
                "Online"
              ) : (
                <>
                  {cleanSpecialCharacters(payment.payment_method)}
                  {payment.card_brand ? ` - ${payment.card_brand}` : null}
                </>
              )}
            </TypographyBoldOnPrint>
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              {formatFinance(parseFloat(payment.value ?? 0))}
            </TypographyBoldOnPrint>
          </Stack>
        );
      })}
      {payment_pending && payment_pending > 0 && (
        <Stack direction="row" justifyContent="space-between">
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            Cobrar do Cliente:
          </TypographyBoldOnPrint>
          <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
            {formatFinance(parseFloat(payment_pending))}
          </TypographyBoldOnPrint>
        </Stack>
      )}
      {changeFor && changeFor > 0 && (
        <>
          <Stack direction="row" justifyContent="space-between">
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              Troco para:
            </TypographyBoldOnPrint>
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              {formatFinance(parseFloat(changeFor))}
            </TypographyBoldOnPrint>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              Troco:
            </TypographyBoldOnPrint>
            <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
              {formatFinance(parseFloat(changeFor - moneyTotal ?? 0))}
            </TypographyBoldOnPrint>
          </Stack>
        </>
      )}
      <Stack direction="row" justifyContent="space-between">
        <TypographyBoldOnPrint variant="body2" color={grey["900"]} gutterBottom>
          Raio de Entrega:
        </TypographyBoldOnPrint>
        <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
          {calculateRadius(distance)}km
        </TypographyBoldOnPrint>
      </Stack>
      <Divider sx={{ my: "2px" }} />
    </Box>
  );
}
